export function formatDateToDDMMYYYY(isoString?: string): string {
  if (!isoString) {
    return '';
  }
  const date = new Date(isoString);

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();

  return `${day}-${month}-${year}`;
}

export function parseAgeToMonths(ageStr: string): [number, number] {
  // có dấu + thì [value,max]
  const isHasPlus = ageStr.includes('+');

  // Xóa khoảng trắng & dấu +
  ageStr = ageStr.trim().replace('+', '');

  // Nếu có dấu "-"
  if (ageStr.includes('-')) {
    const [start, end] = ageStr.split('-');
    const startMonths = start.endsWith('Y') ? convertToMonths(start) - 12 : convertToMonths(start) - 1;
    return [startMonths, convertToMonths(end)];
  }

  // Nếu chỉ có 1 giá trị -> trả về [value, value]
  const value = convertToMonths(ageStr);
  return [value, isHasPlus ? Infinity : value];
}

function convertToMonths(str = ''): number {
  str = str.trim();
  if (str.endsWith('Y')) {
    return parseInt(str) * 12;
  }
  if (str.endsWith('M')) {
    return parseInt(str);
  }
  return -1; // Trường hợp không hợp lệ
}

// Hàm nhận vào ngày sinh và trả về số tháng tính từ ngày sinh đến hiện tại
export function monthsDiff(startDateStr: string) {
  const [day, month, year] = startDateStr.split('-').map(Number);
  const start = new Date(year, month - 1, day);
  const end = new Date();
  const months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
  const daysInMonth = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();
  const dayFraction = (end.getDate() - start.getDate()) / daysInMonth;
  const diff = months + dayFraction;
  return diff.toFixed(2); // 2 chữ số thập phân
}
